import axios from 'axios';
import { getBearerGrantTypeAuthHeaders } from '../../../../helpers/auth_helpers';
import { sortBy } from 'lodash';
function toContainerType(type) {
    switch ((type || '').toLowerCase()) {
        case 'container':
            return 'Container';
        case 'chassis':
            return 'Chassis';
        case 'trailer':
            return 'Trailer';
        default:
            return 'Container';
    }
}
function toDisplay(text) {
    if (!text)
        return '';
    return text
        .toString()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase());
}
export function mapLegToShipment(leg) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    // Derive pickup and delivery from stops (prefer loaded: empty === false)
    const stopsRaw = sortBy(leg.stops || [], 'sequence');
    const pickupCandidates = stopsRaw.filter((s) => { var _a; return ((_a = s.action) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'pickup'; });
    const deliveryCandidates = stopsRaw.filter((s) => { var _a; return ((_a = s.action) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'deliver'; });
    const pickupLoaded = pickupCandidates.find((s) => s.empty === false);
    const deliveryLoaded = deliveryCandidates.find((s) => s.empty === false);
    const pickupStop = pickupLoaded || pickupCandidates[0] || stopsRaw[0];
    const deliveryStop = deliveryLoaded || deliveryCandidates[0] || stopsRaw[stopsRaw.length - 1];
    const stops = stopsRaw.map((s) => {
        var _a, _b, _c, _d, _e, _f;
        return ({
            _id: s === null || s === void 0 ? void 0 : s._id,
            sequence: s.sequence,
            empty: s.empty,
            intent: s.action,
            location: {
                name: Array.isArray(s.location)
                    ? ((_a = s.location[0]) === null || _a === void 0 ? void 0 : _a.name) || ''
                    : ((_b = s.location) === null || _b === void 0 ? void 0 : _b.name) || '',
                address: Array.isArray(s.location)
                    ? ((_c = s.location[0]) === null || _c === void 0 ? void 0 : _c.address) || ''
                    : ((_d = s.location) === null || _d === void 0 ? void 0 : _d.address) || '',
                timezone: Array.isArray(s.location)
                    ? (_e = s.location[0]) === null || _e === void 0 ? void 0 : _e.location_timezone
                    : (_f = s.location) === null || _f === void 0 ? void 0 : _f.location_timezone,
            },
            equipmentIds: (s.equipments || []).map((e) => ({
                id: e.equipment_id,
                containerType: toContainerType(e._equipmentType),
            })),
            isOffsite: Boolean(s.off_site),
            timeline: Object.entries(s.timeline || {})
                .map(([key, entry]) => {
                var _a, _b, _c, _d, _e;
                return ({
                    key,
                    statusCode: (_b = (_a = entry.status) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : 0,
                    statusMessage: (_d = (_c = entry.status) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : '',
                    at: entry.at,
                    actualDate: (_e = entry.meta) === null || _e === void 0 ? void 0 : _e.date,
                });
            })
                .sort((a, b) => a.statusCode - b.statusCode),
        });
    });
    const equipmentIdsFirstStop = ((_a = stops[0]) === null || _a === void 0 ? void 0 : _a.equipmentIds) || [];
    return {
        _id: leg._id,
        shipment_id: leg.shipment_id || '',
        shipment_type: leg.shipment_type,
        shipper: leg.shipper,
        status: toDisplay(leg.status) || '',
        billingStatus: leg.billing_status || '',
        legType: leg.leg_type || '',
        equipmentId: ((_b = equipmentIdsFirstStop[0]) === null || _b === void 0 ? void 0 : _b.id) || '',
        pickup: {
            name: Array.isArray(pickupStop === null || pickupStop === void 0 ? void 0 : pickupStop.location)
                ? ((_d = (_c = pickupStop === null || pickupStop === void 0 ? void 0 : pickupStop.location) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.name) || ''
                : ((_e = pickupStop === null || pickupStop === void 0 ? void 0 : pickupStop.location) === null || _e === void 0 ? void 0 : _e.name) || '',
            address: Array.isArray(pickupStop === null || pickupStop === void 0 ? void 0 : pickupStop.location)
                ? ((_g = (_f = pickupStop === null || pickupStop === void 0 ? void 0 : pickupStop.location) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.address) || ''
                : ((_h = pickupStop === null || pickupStop === void 0 ? void 0 : pickupStop.location) === null || _h === void 0 ? void 0 : _h.address) || '',
        },
        deliver: {
            name: Array.isArray(deliveryStop === null || deliveryStop === void 0 ? void 0 : deliveryStop.location)
                ? ((_k = (_j = deliveryStop === null || deliveryStop === void 0 ? void 0 : deliveryStop.location) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.name) || ''
                : ((_l = deliveryStop === null || deliveryStop === void 0 ? void 0 : deliveryStop.location) === null || _l === void 0 ? void 0 : _l.name) || '',
            address: Array.isArray(deliveryStop === null || deliveryStop === void 0 ? void 0 : deliveryStop.location)
                ? ((_o = (_m = deliveryStop === null || deliveryStop === void 0 ? void 0 : deliveryStop.location) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.address) || ''
                : ((_p = deliveryStop === null || deliveryStop === void 0 ? void 0 : deliveryStop.location) === null || _p === void 0 ? void 0 : _p.address) || '',
        },
        carrier: leg.carrier || '',
        carrier_name: leg.carrier_name || '',
        deliveryOrder: '',
        stops,
        specialInstructions: leg.special_instructions || undefined,
        totalWeight: leg.weight,
        weightUnit: leg.weight_units,
        hubType: leg.hub_type,
    };
}
export async function fetchOrderLegs(orderId, page = 1, limit = 25) {
    var _a, _b;
    try {
        const response = await axios({
            method: 'GET',
            url: `${API_HOST}/api/v3/jobs/orders/${orderId}/legs`,
            params: { page, limit, activeOnly: true },
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: getBearerGrantTypeAuthHeaders(),
            },
        });
        const body = response.data;
        if (typeof body === 'string') {
            if (body.startsWith('<')) {
                throw new Error('Unexpected HTML response from server. Are you logged in?');
            }
            throw new Error('Unexpected non-JSON response from server');
        }
        const legs = Array.isArray(body) ? body : body.data;
        return (legs || []).map(mapLegToShipment);
    }
    catch (err) {
        const anyErr = err;
        const status = (_a = anyErr === null || anyErr === void 0 ? void 0 : anyErr.response) === null || _a === void 0 ? void 0 : _a.status;
        const data = (_b = anyErr === null || anyErr === void 0 ? void 0 : anyErr.response) === null || _b === void 0 ? void 0 : _b.data;
        let message = `Failed to load legs${status ? ` (${status})` : ''}`;
        if (data &&
            typeof data === 'object' &&
            ('error' in data || 'message' in data)) {
            const e = data;
            message = e.error || e.message || message;
        }
        else if (typeof data === 'string' && data.startsWith('<')) {
            message = 'Unexpected HTML response from server. Are you logged in?';
        }
        throw new Error(message);
    }
}
export async function batchUpdateLegSequence(legNumbers) {
    var _a, _b;
    try {
        const response = await axios({
            method: 'PUT',
            url: `${API_HOST}/api/v3/jobs/legs/batch/sequence`,
            data: {
                leg_numbers: legNumbers,
            },
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: getBearerGrantTypeAuthHeaders(),
            },
        });
        return response.data;
    }
    catch (err) {
        const anyErr = err;
        const status = (_a = anyErr === null || anyErr === void 0 ? void 0 : anyErr.response) === null || _a === void 0 ? void 0 : _a.status;
        const data = (_b = anyErr === null || anyErr === void 0 ? void 0 : anyErr.response) === null || _b === void 0 ? void 0 : _b.data;
        let message = `Failed to update leg sequence${status ? ` (${status})` : ''}`;
        if (data &&
            typeof data === 'object' &&
            ('error' in data || 'message' in data)) {
            const e = data;
            message = e.error || e.message || message;
        }
        throw new Error(message);
    }
}
